<template>
  <!-- 税务闭环 -->
  <div class="taxation">
    <div class="taxation-title" v-if="taxation">
      <div class="info taxation-title-info flexItems">
        <div class="indexTitle">
          <p class="flexItems"><span></span>税务闭环</p>
          <p>Tax Administration</p>
        </div>
      </div>
    </div>
    <div class="taxation-content">
      <div class="info taxation-content-info">
        <div class="taxation-content-title flexBetween flexItems">
          <div class="taxation-content-left">
            <span>五流合一</span>真实数据源
          </div>
          <div class="taxation-content-right">
            <p>企业运输方案提前做，管家式服务更省心</p>
            <p>货运江湖，您征战市场，决胜“江湖”的忠实伙伴</p>
          </div>
        </div>
        <div class="taxation-content-con">
          <div class="taxation-content-icon flexItems">
            <div class="taxation-icon flexItems">
              <img src="../../static/img/swIcon1.png" width="95" alt="" />
              <span class="taxation-span"></span>
            </div>

            <div class="taxation-icon flexItems">
              <img src="../../static/img/swIcon2.png" width="95" alt="" />
              <span class="taxation-span"></span>
            </div>
            <div class="taxation-icon flexItems">
              <img src="../../static/img/swIcon3.png" width="95" alt="" />
              <span class="taxation-span"></span>
            </div>
            <div class="taxation-icon flexItems">
              <img src="../../static/img/swIcon4.png" width="95" alt="" />
              <span class="taxation-span"></span>
            </div>
            <div class="taxation-icon flexItems">
              <img src="../../static/img/swIcon5.png" width="95" alt="" />
            </div>
          </div>
          <div class="taxation-content-text flex">
            <div class="taxation-textItem">
              <p>合同流</p>
              <p>与船东、司机、货主分别签订电子运输合同，合法合规</p>
            </div>
            <div class="taxation-textItem">
              <p>货物流</p>
              <p>货物从源头开始，所有流转过程清晰，有据可查</p>
            </div>
            <div class="taxation-textItem">
              <p>资金流</p>
              <p>清晰明了的资金走向，各环节合法合规</p>
            </div>
            <div class="taxation-textItem">
              <p>票据流</p>
              <p>平台为货主提供合法增值税运输税票</p>
            </div>
            <div class="taxation-textItem">
              <p>信息流</p>
              <p>大数据采集、整理、加工实时推送各类信息</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 手机端 -->
    <div class="phone-taxation">
      <div class="indexTitle">
        <p class="flexItems"><span></span>税务闭环</p>
        <p>Tax Administration</p>
      </div>
      <div class="phone-taxation-banner">
        <img src="../../static/img/phone2.png" alt="" />
      </div>
      <div class="phone-taxation-con">
        <div class="taxation-content-title">
          <div class="taxation-content-left">
            <span>五流合一</span>
            <p>真实数据源</p>
          </div>
          <div class="taxation-content-right">
            <p>企业运输方案提前做，管家式服务更省心</p>
            <p>货运江湖，您征战市场，决胜“江湖”的忠实伙伴</p>
          </div>
        </div>
        <div class="phone-taxation-icons">
          <ul class="flex">
            <li>
              <img src="../../static/img/phoneIcon1.png" width="66" alt="" />
              <p>合同流</p>
            </li>
            <span></span>
            <li>
              <img src="../../static/img/phoneIcon2.png" width="66" alt="" />
              <p>货物流</p>
            </li>
            <span></span>
            <li>
              <img src="../../static/img/phoneIcon3.png" width="66" alt="" />
              <p>资金流</p>
            </li>
          </ul>
          <ul class="flex">
            <li>
              <img src="../../static/img/phoneIcon4.png" width="66" alt="" />
              <p>票据流</p>
            </li>
            <span></span>
            <li>
              <img src="../../static/img/phoneIcon5.png" width="66" alt="" />
              <p>信息流</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <span class="zmldown2"></span>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["taxation"],
};
</script>
<style scoped="scoped">
/* 税务筹划 */

.taxation {
  width: 100%;
  height: 100%;
}

.taxation-title {
  width: 100%;
  height: 291px;
  overflow: hidden;
  background: url(../../static/img/zmlbg.jpg) no-repeat right center;
  background-size: cover;
  background-color: #127bfd;
}

.indexTitle p:nth-of-type(1) {
  color: #fff;
}

.taxation-title-info .indexTitle p:nth-of-type(1) span {
  background-color: #fff;
}

.indexTitle p:nth-of-type(2) {
  color: rgba(255, 255, 255, 0.8);
}

.taxation-content {
  width: 100%;
  height: auto;
  background-color: #fff;
}

.taxation-content-info {
  padding-top: 90px;
}

.taxation-content-left {
  font-size: 54px;
  letter-spacing: 4px;
}

.taxation-content-left span {
  color: #127bfd;
  margin-right: 50px;
}

.taxation-content-right {
  text-align: right;
  font-size: 22px;
  color: #282828;
  line-height: 35px;
}

.taxation-content-con {
  padding-top: 96px;
}

.taxation-span {
  display: block;
  width: 130px;
  height: 8px;
  background-color: #f4f4f6;
  margin: 0 35px;
}

.taxation-textItem {
  min-width: 218px;
  margin-right: 78px;
}

.taxation-textItem > p:nth-of-type(1) {
  font-size: 24px;
  color: #282828;
  margin-top: 50px;
  font-weight: bold;
}

.taxation-textItem > p:nth-of-type(2) {
  color: #666;
  font-size: 16px;
  line-height: 26px;
  margin-top: 28px;
}

.phone-taxation {
  display: none;
}

@media only screen and (max-width: 1600px) {
  .taxation {
    display: flex;
    flex-flow: column;
  }
  .taxation-content {
    flex: 1;
  }
  .taxation-content-info {
    padding: 30px;
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-around;
  }
  .taxation-content-left {
    /* font-size: 30px; */
  }
  .taxation-content-con {
    padding-top: 30px;
  }
  .taxation-icon {
    width: 20%;
  }
  .taxation-icon img {
    width: 30%;
  }
  .taxation-span {
    flex: 1;
    margin: 0 10%;
  }
  .taxation-textItem {
    width: 20%;
    margin-right: 0;
    padding-right: 50px;
  }
  .taxation-textItem > p:nth-of-type(1) {
    margin-top: 25px;
  }
}

@media only screen and (max-width: 750px) {
  .taxation-title,
  .taxation-content {
    display: none;
  }
  .phone-taxation {
    display: flex;
    flex-flow: column;
    height: 100%;
  }
  .phone-taxation-banner img {
    width: 100%;
  }
  .phone-taxation-con {
    padding: 0 23px;
    flex: 1;
    display: flex;
    flex-flow: column;
    justify-content: center;
  }
  .taxation-content-left {
    font-size: 40px;
    font-weight: bold;
    padding-top: 0px;
  }
  .taxation-content-right {
    text-align: left;
    font-size: 14px;
    line-height: 25px;
    margin: 20px 0;
  }
  .phone-taxation-icons ul {
    /* margin-top: 20px; */
  }
  .phone-taxation-icons ul li {
    text-align: center;
  }
  .phone-taxation-icons ul span {
    display: block;
    width: 26px;
    height: 4px;
    background: rgba(244, 244, 246, 1);
    border-radius: 4px;
    margin: 0px 17px;
    margin-top: 31px;
  }
}

@media only screen and (max-width: 320px) {
  .phone-taxation-icons ul span {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index_taxation.vue